
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fabrics/page/[page]",
      function () {
        return require("private-next-pages/fabrics/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fabrics/page/[page]"])
      });
    }
  